import c from 'classnames';
import styles from './SkeletonCard.module.css';

type Props = {
  containerClassName?: string;
};

export function SkeletonCard({ containerClassName }: Props) {
  return <div className={c(styles.container, containerClassName)} />;
}
